/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

import { AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, takeUntil } from 'rxjs/operators';

/**
 * monitors the external component and mirrors it's error state
 * Somewhat of a placeholder pending this https://mocasystems.atlassian.net/browse/TP-4329
 */
export function maintainParentErrorParity(
	externalControl: AbstractControl,
	internalControl: AbstractControl,
	cancel: Observable<any>
) {
	externalControl.statusChanges.pipe(startWith(externalControl.status), takeUntil(cancel)).subscribe((s) => {
		if (externalControl.errors && !internalControl.errors) {
			internalControl.setErrors(externalControl.errors, { emitEvent: false });
		} else if (!externalControl.errors && internalControl.errors) {
			internalControl.setErrors(null, { emitEvent: false });
		}
	});
}

/**
 * Monitors the external component and mirrors it's required state
 */
export function maintainParentRequiredParity(
	externalControl: AbstractControl,
	internalControl: AbstractControl,
	cancel: Observable<boolean>
) {
	externalControl.valueChanges.pipe(startWith(externalControl.value), takeUntil(cancel)).subscribe((s) => {
		if (
			externalControl.hasValidator(Validators.required) &&
			!internalControl.hasValidator(Validators.required)
		) {
			internalControl.setValidators([Validators.required]);
			internalControl.updateValueAndValidity({ emitEvent: false });
		} else if (
			!externalControl.hasValidator(Validators.required) &&
			internalControl.hasValidator(Validators.required)
		) {
			internalControl.removeValidators(Validators.required);
			internalControl.updateValueAndValidity({ emitEvent: false });
		}
	});
}
